import { useSelector } from "react-redux";
import { Box, Button, Link } from "@mui/material";
import { RootState } from "shared/store/store";
import { CommentItem } from "./CommentItem";
import styles from "./styles/CommentsList.module.scss";
import { debounceFunction, downloadDocument } from "../../utils/helpers";
import { Fragment, useEffect, useState } from "react";
import { apiInstance } from "shared/api/config/apiInstance";

export const CommentsList = () => {
  const { comments } = useSelector((state: RootState) => state.comments);
  const [displayedComments, setDisplayedComments] = useState<number>(3);
  const [key, setKey] = useState<number>(0);

  const validateScrollEnd = (value: any) => {
    const { scrollTop, scrollHeight, clientHeight } = value.target;

    debounceFunction(() => {
      const esFinalScroll = clientHeight + scrollTop + 10 >= scrollHeight;
      if (esFinalScroll) {
        setDisplayedComments((prevCount) => prevCount + 3);
      }
    });
  };

  useEffect(() => {
    // Incrementar la clave cada vez que comments cambie y recargue el CommentItem
    setKey((prevKey) => prevKey + 1);
  }, [comments]);

  return (
    <Box className={styles.commentListContainer} data-testid="comments_list">
      {comments?.length > 0 ? (
        <Box
          className={styles.commentsList}
          onScroll={validateScrollEnd}
          data-testid="box_content"
        >
          {comments?.slice(0, displayedComments).map((comment, index) => (
            <Fragment key={`${comment.id}_${key}`}>
              <CommentItem
                key={`${comment.id}_${key}`}
                id={comment.id}
                comment={comment.message}
                author={comment.author}
                date={comment.date}
                wasUpdated={comment.wasUpdated}
                privacy={comment.privacy}
                data-testid={`comment_${index}`}
                modifiedAt={comment?.modifiedAt || ""}
                attachments={comment.attachments}
              />
            </Fragment>
          ))}
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", color: "#666", mt: 2, p: 2 }}>
          No hay comentarios aún
        </Box>
      )}
    </Box>
  );
};
